import { GroupBy, ListContentAction } from '../../../store/constants';
import { http } from '../../../api/axios';
import { cartConfig } from '../../../config';
import * as types from '../../../store/constants';

export const changeAmountGroupedItem = (
    groupItem: {
        id: string;
        key: GroupBy;
    },
    amount: number,
    command: ListContentAction
) => {
    return http
        .put(
            cartConfig().endpointBulk,
            {
                amount,
                [getRefKey(groupItem.key)]: groupItem.id
            },
            {
                pathParams: {
                    source: types.SOURCE_QUANTITY,
                    kind: 'filter',
                    action: command
                }
            }
        )
        .then(res => res.data);
};

function getRefKey(key: GroupBy) {
    switch (key) {
        case types.GROUPBY_BUNDLES:
            return 'bundleRef';
        case types.GROUPBY_LISTS:
            return 'selectionListRef';
        case types.GROUPBY_PRODUCTS:
            return 'products';
    }
}
